module.exports = __webpack_public_path__ + "static/media/radio-off.7d3c3cc9.svg";